export const blobToURL = (blob) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = function () {
      const base64data = reader.result;
      resolve(base64data);
    };
  });
};

export const readFileAsUnit8Array = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload(() => {
      const unit8Array = new Uint8Array(reader.result);
      resolve(unit8Array);
    });
    reader.onerror((err) => console.log(err));
  });
};

// export const toDataURL = (url) => {
//   return new Promise((resolve) => {
//     const reader = new FileReader();
//   });
// };

export const fileToBlob = async (file, handleUpdate) => {
  const { content, size } = file;
  let chunks = [];
  let i = 0;
  const totalCount = Math.round(size / 250000);

  for await (const chunk of content) {
    if (handleUpdate) {
      handleUpdate(i, totalCount);
    }
    chunks.push(chunk);
    i++;
  }

  return new Blob(chunks);
};
